import React, { useState } from 'react';
import { Grid, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { format, parseISO } from 'date-fns';
import { actions as companyActions } from '../../../../redux/reducers/companyReducer';
import { CustomReactSelect, CustomButton, CustomModal, CustomCalendar } from '../../../shared';
import { DownloadCloudIcon, CalendarIcon } from '../../../../assets';
import { useNavigate } from 'react-router-dom';
import routeNames from '../../../../routes/routeNames';

const FilterBar = (props) => {
    const {} = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [calendarOpen, setCalendarOpen] = useState(false);
    const { startDateRange, endDateRange } = useSelector((state) => state.filter);
    const dateRange = `${format(parseISO(startDateRange), 'MMM dd, yyyy')} -  ${format(parseISO(endDateRange), 'MMM dd, yyyy')}`;
    const { companyOptions, company } = useSelector((state) => state.company);
    const { userDetails: { is_admin } } = useSelector((state) => state.user);
    const { setCompany } = companyActions;

    const handleNavigateToDashboard = () => {
        navigate(routeNames.DASHBOARD);
    };

    const handleCompanyChange = (option) => {
        dispatch(setCompany(option));
        handleNavigateToDashboard();
    };

    const handleShowCalendar = () => {
        setCalendarOpen(!calendarOpen);
    };

    return (
        <Grid container className="flex-row-justify-start mb-24px mt-10px">
            <Grid item xs={6}>
                <Box className="flex-row gap-12"> 
                    <Box className="w-50">
                        <CustomReactSelect
                            customStyle={{ borderRadius: '50px' }}
                            handleFilter={handleCompanyChange}
                            options={companyOptions}
                            placeholder="Select Company"
                            selectedOption={{
                                label: company.name,
                                value: company.id
                            }}
                        />
                    </Box>
                    {/* Select Inputs */}
                    <Box className="w-70">
                        <CustomButton
                            buttonColor="#FFFFFF"
                            handleClick={handleShowCalendar}
                            icon={<CalendarIcon />}
                            title={dateRange}
                            titleColor="#344054"
                        />
                        <CustomModal
                            component={<Box className="custom-modal-calendar-container">
                                <CustomCalendar closeModal={handleShowCalendar} />
                            </Box>}
                            handleClose={handleShowCalendar}
                            modalOpen={calendarOpen}
                            onClose={handleShowCalendar}
                        />
                    </Box>
                </Box>
            </Grid>
            
        </Grid>
    );
};

export default FilterBar;
